import React from 'react';
import SeasonsTableList from '../../shared/Tables/SeasonsTableList';
import Axios from 'axios';

class SeasonsAdmin extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			seasons: []
		};
	
		this.loadSeasonsFromApi = this.loadSeasonsFromApi.bind(this);
	}

	componentDidMount() {
		this.loadSeasonsFromApi();
	}

	loadSeasonsFromApi() {
		var _this = this;
		Axios.get('/api/seasons/').then(function (response) {
			_this.setState({seasons: response.data});
		});
	}

	render() {
		//console.log('SeasonsAdmin: render')
		return (
			<div className="row">
			<div className="col-md-12">

				<h5>Saisons</h5>
				<div className="card">
					<div className="card-header">
						<i className="fa fa-th-large"></i>
						Saisons
					</div>

					<div className="card-block">
					<SeasonsTableList seasons={this.state.seasons}/>
					</div>
				</div>
			</div>
			</div>
		);
	}

}

export default SeasonsAdmin;